/**
 * V70 Tournament — 사용자 측 Route Guard
 *
 * 역할:
 *   - tournament 사용자 페이지 Route 전용
 *   - BE 설정 (ON/OFF + 대상자) 에 따라 접근 차단
 *   - 관리자 자동 허용 안 함 (사용자 지시 §1)
 *   - 설정 조회 실패 시 OFF 처리 (사용자 지시 §4)
 *
 * admin 설정 페이지 (/admin/tournament-settings) 는 **별도 ProtectedRoute + system_admin 체크**
 */
import React from 'react';
import { Loader } from 'lucide-react';
import { useMyTournamentAccess } from '../shared/hooks/useMyTournamentAccess';

interface Props {
  children: React.ReactNode;
}

export function TournamentAccessGuard({ children }: Props) {
  const { isLoading, accessible, reason } = useMyTournamentAccess();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 400 }}>
        <Loader size={24} className="spin" />
      </div>
    );
  }

  if (!accessible) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>게임대회 접근 불가</h2>
        <p style={{ color: 'var(--color-gray-600)' }}>{reason || '접근 권한이 없습니다.'}</p>
      </div>
    );
  }

  return <>{children}</>;
}
